import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

import ActionButton from '../../ActionButton'
import Picture from '../../Picture'
import RichText from '../../RichText'

export const Container = styled.hgroup<{ $color?: string }>`
  --hero_background-color: ${({ $color }) => $color};
  --hero_text-offset: 205%;
  display: grid;
  grid-template-rows:
    [header] var(--g_height__header)
    [content] auto
    [intersection] ${pxToRem(260)}
    [picture] auto;
  grid-template-columns:
    [gutter] ${pxToRem(16)}
    [content] 1fr;
  background: var(--hero_background-color);
  @media ${mq(sizes.tablet)} {
    --hero_text-offset: 105%;
    grid-template-rows:
      [header] var(--g_height__logo)
      [content] auto
      [intersection] 23vh
      [picture] 1fr;
    grid-template-columns:
      [gutter] calc(380 / 1440 * 100vw)
      [content] 1fr
      [gutter-right] ${pxToRem(32)};
  }
`
export const Wrapper = styled.div`
  position: relative;
  z-index: 5;
  grid-column: gutter / span 2;
  grid-row: content / span 1;
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  padding-inline: ${pxToRem(16)};
  padding-block: ${pxToRem(80)};
  @media ${mq(sizes.tablet)} {
    grid-column: content / span 2;
    min-height: 40vh;
    width: 100%;
    max-width: max(${pxToRem(912)}, calc(912 / 1060 * 100%));
    padding-block-start: ${pxToRem(80)};
    padding-inline: ${pxToRem(32)};
    margin-inline-start: auto;
  }
`
export const Title = styled.h1`
  ${({ theme }) => theme.textStyles.m375_h1}
  text-wrap: balance;
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h1}
  }
`
export const TitleContent = styled(motion.span)`
  display: inline-block;
`

export const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  max-width: calc(223 / 343 * 100%);
  margin-inline-start: auto;
  overflow: hidden;
  @media ${mq(sizes.tablet)} {
    flex-flow: row;
    max-width: none;
    margin-inline-start: unset;
    justify-content: space-between;
  }
`
export const RichTextWrapper = styled(motion.div)`
  @media ${mq(sizes.tablet)} {
    max-width: calc(564 / 912 * 100%);
  }
`

export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_bodyBig}
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.d1440_bodyBig}
  }
`
export const _ActionButton = styled(ActionButton)`
  justify-self: start;
  white-space: nowrap;
  @media ${mq(sizes.tablet)} {
    margin-inline-start: auto;
    align-self: flex-start;
  }
`
export const _Picture = styled(motion.create(Picture))`
  position: relative;
  z-index: 2;
  grid-column: content / span 1;
  grid-row: intersection / span 2;
  opacity: 0;
  transform: scale(1.2) translateX(10%);

  @media ${mq(sizes.tablet)} {
    grid-column: gutter / span 2;
    grid-row: content / span 3;
  }
`
export const BigBG = styled.div`
  position: relative;
  z-index: 1;
  grid-column: gutter / span 2;
  grid-row: intersection / span 1;
  background: var(--hero_background-color);
  @media ${mq(sizes.tablet)} {
    max-height: 100svh; // @TODO pb here
    grid-row: header / span 3;
    grid-column: gutter / span 3;
  }
`
export const ContentBG = styled(motion.div)`
  position: relative;
  z-index: 4;
  grid-column: gutter / span 2;
  grid-row: header / span 2;
  background: var(--hero_background-color);
  @media ${mq(sizes.tablet)} {
    grid-column: content / span 2;
  }
`
